import React, {h, Component} from 'preact';

export default class BuyProcessStep extends Component {

    chooseBuyerStage(buyerStage) {
        $.get('update-buyrequest-json', {
            buyerStage,
            propertyType: this.props.parent.state.homeType,
            priceRange: this.props.parent.state.lowRange + '-' + this.props.parent.state.highRange
        });
        this.props.parent.setState({buyerStage, currentStep: 'BUY_CREDIT_SCORE'});
    }

    componentDidMount() {
        trackEvent('Flow', 'BuyRequest', 'buyStep3').withGA().withOptimizely();
        trackEvent('Flow', 'BuyRequest', 'buyerLoadedStep4').withGA().withOptimizely();
    }

    render() {
        return <div className="flow-step">
            <div className="flow-step-text hidden-xs">
                <img className ="icon-desktop" src={global.imageBaseUrl + '/buysell/svg/save-with-upnest.svg'} />
                <div>The average UpNest Home Buyer finds their new home within 29 days.</div>
            </div>

            <div className="flow-step-header-text">
                <strong>Where are you in the buying process?</strong>
            </div>
            <div className="option-div">
                <div id="buyer-stage-div">
                    <div className="choice-button buyer-stage-button" onClick={() => this.chooseBuyerStage(0)}>
                        <img src={global.imageBaseUrl + '/buysell/svg/just-started.svg'}/>
                        <div className="button-text" style={{overflow: 'hidden'}}>
                            <span>Just Started</span>
                        </div>
                    </div>
                    <div className="choice-button buyer-stage-button" onClick={() => this.chooseBuyerStage(2)}>
                        <img src={global.imageBaseUrl + '/buysell/svg/ready-to-bid.svg'}/>
                        <div className="button-text" style={{overflow: 'hidden'}}>
                            <span>Ready to Bid</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flow-spacer"/>

            <div className="bottom-banner">
                <div className="status-normal">
                    <div className="title"><img src={global.imageBaseUrl + '/buysell/svg/save-with-upnest.svg'}/> Save with UpNest</div>
                        <div className="subtitle subtitle-large">The average UpNest Home Buyer finds their new home within 29 days.</div>
                    </div>
                <div className="status-normal subtitle subtitle-small" style={{'font-size': '12px', 'opacity': '0.87', 'letter-spacing': '0.5px'}}>
                    <div>The average UpNest Home Buyer finds their new home within 29 days.</div>
                </div>
            </div>
        </div>;
    }
}
